import React from 'react';
import { motion, Variants } from 'framer-motion';
import { Hand } from 'lucide-react';
import { cn } from '@/lib/utils';

interface HandLoaderProps {
    loaderClassname?: string
}

const waveAnimation = {
    wave: {
        rotate: [0, 20, -10, 20, -10, 0],
        transition: {
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut',
        },
    },
};

const exitAnimation = {
    initial: { opacity: 1 },
    exit: { opacity: 0, scale: 0.95, transition: { duration: 0.5 } },
};

const WaveLoader: React.FC<HandLoaderProps> = ({ loaderClassname }) => {
    return (
        <motion.div
            className={
                cn(
                    "w-64 h-64 rounded-full bg-primary relative overflow-hidden flex items-center justify-center",
                    loaderClassname
                )
            }
            animate="blink"
            {...exitAnimation}
        >
            <div
                className='flex flex-col items-center justify-center bg-primary text-secondary rounded-full p-12'
            >
                <motion.div
                    variants={waveAnimation as Variants}
                    animate="wave"
                >
                    <Hand className="text-secondary bg-primary h-24 w-24 lg:h-32 lg:w-32" strokeWidth={1} size={64} />
                </motion.div>
            </div>
        </motion.div>
    );
};

export default WaveLoader;
